<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h">Part One</p>
<p class="part-h1">Reason and</p>
<p class="part-h1">Madness,</p>
<p class="part-h1">1720</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?04804e23